<fui-heading [text]="betaProgram?.title || 'Loading...'" [level]="2" fontSize="f7"></fui-heading>
@if (betaProgram) {
  <span class="t-16 bold" [innerHTML]="helperService.makeHtml(betaProgram.description)"></span>
  <myp-inline-loader [loading]="loading" height="400px" spinnerName="browseExchange"></myp-inline-loader>
  <div class="m-y-20">
    <a [routerLink]="['/account/notification_preferences']" class="btn btn-secondary btn-sm">Manage Notification Preferences</a>
  </div>
  @if (betaProgram.products?.length) {
    <div class="m-t-30">
      <fui-heading [text]="'Products in This Beta Program'" [level]="2" fontSize="f7"></fui-heading>
      <div class="text-muted m-b-20">Expand products below to access downloads and beta content.</div>
      @for (product of betaProgram.products; track product) {
        <div class="m-b-20 content-bg">
          <div class="d-flex">
            <div class="d-flex pointer w-full" (click)="getProductDetails(product)">
              <div style="width: 30px">
                @if (!product.loading) {
                  <fa-icon [icon]="product.expanded ? 'chevron-down' : 'chevron-right'" class="m-r-10 brandfont-black t-20"></fa-icon>
                }
                @if (product.loading) {
                  <fa-icon icon="spinner" [animation]="'spin'" class="m-r-10 brandfont-black t-20"></fa-icon>
                }
              </div>
              <span class="brandfont-black t-20">{{ product.title }}</span>
              @if (productDetails[product.id]) {
                <div style="width: 40px; margin-left: auto">
                  <img [src]="productDetails[product.id].product.imageUrl" style="width: 35px" />
                </div>
              }
            </div>
          </div>
          @if (productDetails[product.id] && product.expanded) {
            <div>
              <hr />
              @if (
                !productService.isGettingProducts &&
                !productService.productsByProductID[product.id] &&
                productDetails[product.id].product.categoryId != "hardware" &&
                productDetails[product.id].product.stringId != "ucapp" &&
                productDetails[product.id].product.stringId != "uc4" &&
                productDetails[product.id].product.stringId != "uc4.beta"
              ) {
                <div class="m-b-50">
                  First you must register a copy of {{ productDetails[product.id].product.title }} to your account.
                  <br />
                  <button class="btn btn-primary m-t-20" (click)="claimBetaProduct(product)">Register {{ productDetails[product.id].product.title }}</button>
                </div>
              }
              @if (
                productService.productsByProductID[product.id] ||
                productDetails[product.id].product.categoryId == "hardware" ||
                productDetails[product.id].product.stringId == "ucapp" ||
                productDetails[product.id].product.stringId == "uc4" ||
                productDetails[product.id].product.stringId == "uc4.beta"
              ) {
                <myp-installer-buttons
                  [isSideBar]="false"
                  [betaOnly]="true"
                  [downloads]="productDetails[product.id].downloads"
                  [product]="productDetails[product.id].product"
                  [firmwareList]="productDetails[product.id].firmware"
                ></myp-installer-buttons>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}
